export const active = '-is-active';
export const disabled = '-is-disabled';
export const open = '-is-open';
export const expanded = '-is-expanded';
export const selected = '-is-selected';
export const invalid = '-is-invalid';
export const fadeOut = '-fade-out';
export const fadeIn = '-fade-in';
export const complete = '-complete';